import moment from 'moment';
import 'moment-timezone';

export const useDateTimeFormat = () => {
  const userTimezone = () => moment.tz.guess();

  const formatedDatetime = (date, format) => moment(date).tz(userTimezone()).format(format);

  const addedDate = (date, days) => moment(date).add(days, 'days');

  /**
   * Check date is between
   * format => MMMM D YYYY HH:mm A
   * @param {String} compared
   * @param {String} start
   * @param {String} end
   * @return {Boolean} true => if compared date between start and end
   */
  const isBetween = (compared, start, end) => {
    return moment(new Date(formatedDatetime(compared, 'LLL'))).isBetween(
      moment(new Date(formatedDatetime(start, 'LLL'))),
      moment(new Date(formatedDatetime(end, 'LLL'))),
      undefined,
      '[]'
    );
  };

  /**
   *
   * @param {Array} startEndSource array contains start date and end date of source date
   * @param {Array} startEndCompared array contains start date and end date of compared date
   * @returns {Boolean} true => if the source date range is between compared date range both inner and outer scopes
   */
  const isTimeOverlapped = (startEndSource, startEndCompared) => {
    return (
      isBetween(startEndSource[0], startEndCompared[0], startEndCompared[1]) ||
      isBetween(startEndSource[1], startEndCompared[0], startEndCompared[1]) ||
      isBetween(startEndCompared[0], startEndSource[0], startEndSource[1]) ||
      isBetween(startEndCompared[1], startEndSource[0], startEndSource[1])
    );
  };

  return {
    userTimezone,
    formatedDatetime,
    addedDate,
    isBetween,
    isTimeOverlapped
  };
};
